import { Box, Container, SxProps, Theme, useTheme } from '@mui/material';
import { useSettingsContext } from '@zeta-core';
import { ReactNode } from 'react';

const PADDING = {
  lg: { px: 5, py: 2 },
  sm: { px: 3, py: 3 },
  clientProfile: { px: 2, py: 2 },
};

interface IDashboardContainerType {
  children: ReactNode;
  disablePadding?: boolean;
  disableRestrictStretch?: boolean;
  variant?: keyof typeof PADDING;
  sx?: SxProps<Theme>;
  containerSx?: SxProps<Theme>;
  ref?: any;
  backgroundColor?: boolean;
}

const DashboardContainer = ({
  disablePadding,
  disableRestrictStretch,
  variant = 'lg',
  containerSx,
  children,
  backgroundColor,
  ref,
  ...other
}: IDashboardContainerType) => {
  const settings = useSettingsContext();
  const px = disablePadding ? 0 : PADDING[variant].px;
  const py = disablePadding ? 0 : PADDING[variant].py;
  const stretch = settings.themeStretch ? false : 'xl';
  const theme = useTheme();

  return (
    <Box {...other} minHeight="100%" sx={{ background: backgroundColor && theme.palette.grey[200], position: 'relative' }}>
      <Container maxWidth={!disableRestrictStretch ? stretch : false} sx={{ minHeight: '100%', px, py, ...containerSx }} disableGutters ref={ref}>
        {children}
      </Container>
    </Box>
  );
};

export default DashboardContainer;
